import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import style from "css/signup/signupComplete.module.css";
import SEOMeta from "component/app/SEOMeta";

function SignUpComplete() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const completed = location.state?.completed;
  const isInvite = location.state?.inviteYn;

  useEffect(() => {
    if (!completed) {
      navigate("/signup", { replace: true });
    }
  }, [completed, navigate]);

  if (!completed) return null;

  const handleGoHome = () => {
    window.location.href = "/";
  };

  // 초대 가입은 승인 절차 없이 바로 가입 완료
  if (isInvite) {
    return (
      <div className={style.page}>
        <SEOMeta
          title={t("signup.complete.seo.title")}
          description={t("signup.complete.seo.description")}
          keywords={t("signup.complete.seo.keywords")}
        />
        <div className={style.inviteContent}>
          <img
            className={style.inviteIcon}
            src={`${process.env.REACT_APP_CLIENT_URL}img/signup/signup_check.svg`}
            alt=""
          />
          <h1 className={style.inviteTitle}>
            {t("signup.complete.invite.title")}
          </h1>
          <p className={style.inviteMessage}>
            {t("signup.complete.invite.message")}
          </p>
          <button
            type="button"
            className={style.goBtn}
            onClick={() => {
              window.location.href = window.location.origin + "/service/";
            }}
          >
            {t("signup.complete.invite.goSite")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={style.page}>
      <SEOMeta
        title={t("signup.complete.seo.title")}
        description={t("signup.complete.seo.description")}
        keywords={t("signup.complete.seo.keywords")}
      />
      <Link
        to="/"
        className={style.logoLink}
      >
        <img
          alt="all Place"
          src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_dark.png`}
        />
      </Link>
      <div className={style.card}>
        <div className={style.iconCircle}>
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}img/signup/hourglass.svg`}
            alt=""
          />
        </div>
        <span className={style.badge}>{t("signup.complete.badge")}</span>
        <h1 className={style.title}>{t("signup.complete.title")}</h1>
        <div className={style.notice}>
          <img
            className={style.noticeIcon}
            src={`${process.env.REACT_APP_CLIENT_URL}img/signup/info_yellow.svg`}
            alt=""
          />
          <div>
            <p className={style.noticeTitle}>
              {t("signup.complete.noticeTitle")}
            </p>
            <p className={style.noticeBody}>{t("signup.complete.noticeBody")}</p>
          </div>
        </div>
        <button
          type="button"
          className={style.confirmBtn}
          onClick={handleGoHome}
        >
          {t("signup.complete.confirm")}
        </button>
        <div className={style.divider} />
        <p className={style.question}>{t("signup.complete.question")}</p>
        <button
          type="button"
          className={style.contactBtn}
          onClick={() => navigate("/", { state: { link: "contact" } })}
        >
          {t("signup.complete.contact")}
        </button>
      </div>
    </div>
  );
}

export default SignUpComplete;
